import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/Badge';
import { Tooltip } from '@/components/Tooltip';
import {
  KARTOTEKA_KIND_BADGE_COLOR,
  KARTOTEKA_KIND_LABEL_KEY,
  type KartotekaKind,
} from '@/lib/kartoteka-kind';

/**
 * Chip kartoteki pokolorowany wg pochodzenia (systemowa = zielony, utworzona = pomarańczowy).
 * Jedyny sposób renderowania badge kartoteki — kolor pochodzi z `lib/kartoteka-kind.ts`,
 * NIE wpisywać klas kolorów lokalnie. Znaczenie koloru niesie tooltip z biblioteki UI
 * (Radix, hover + focus klawiaturą), nie natywny `title`.
 *
 * Badge owija `<span>`-trigger, bo Radix Tooltip (asChild) potrzebuje elementu przekazującego
 * ref — Badge jest zwykłym komponentem funkcyjnym bez forwardRef.
 */
export function KartotekaBadge({
  kind,
  name,
  className,
  'data-testid': dataTestId,
}: {
  kind: KartotekaKind;
  name: string;
  className?: string;
  'data-testid'?: string;
}) {
  const { t } = useTranslation();
  return (
    <Tooltip content={t(KARTOTEKA_KIND_LABEL_KEY[kind])}>
      <span className="inline-flex max-w-full">
        <Badge
          color={KARTOTEKA_KIND_BADGE_COLOR[kind]}
          className={className}
          data-testid={dataTestId}
        >
          {name}
        </Badge>
      </span>
    </Tooltip>
  );
}
